import styled from "@emotion/styled";

import { theme } from "../../../../../../Controls/Internals/ThemeProvider/CandyTheme/ThemeShorthand";
import { UploadFileStatuses } from "../Types";

export interface RootProps {
    hovered: boolean;
}

export const Root = styled.div<RootProps>(props => ({
    borderRadius: theme(props).size(1),
    padding: theme(props).size(1),
    backgroundColor: `rgba(0,0,0, ${props.hovered ? "0.06" : "0"})`,
    display: "grid",
    transition: "all .4s ease",
}));

export const FileTitle = styled.div(props => ({
    ...theme(props).typography.primary.css(),
    position: "relative",
    display: "flex",
    flexDirection: "row",
    boxSizing: "border-box",
}));

export interface FileNameProps {
    status?: UploadFileStatuses;
}

export interface IconContainerProps {
    isLoading: boolean;
}

export const RightIconContainer = styled.span<{ isDefaultCursor: boolean }>(props => ({
    color: theme(props).icons.color,
    cursor: props.isDefaultCursor ? "default" : "pointer",
    marginLeft: "5px",
    ":hover": {
        color: theme(props).icons.hoverColor,
    },
}));

export const FileIconContainer = styled.span<IconContainerProps>(props => ({
    color: theme(props).icons.color,
}));

export const FileName = styled.div<FileNameProps>(props => ({
    ...theme(props).typography.primary.css(),
    flex: "0 1 100%",
    color:
        props.status === UploadFileStatuses.error
            ? props.theme.candy.typography.inactive.color
            : props.theme.candy.typography.primary.color,
}));

export const FileException = styled.div(props => ({
    color: props.theme.candy.semanticColors.danger.color,
}));
export const FileExceptionWarning = styled.div(props => ({
    color: props.theme.candy.semanticColors.warning.color,
}));

export const FileCountInstances = styled.span(props => ({
    color: props.theme.candy.typography.secondary.color,
}));

export const Underline = styled.span(() => ({
    textDecoration: "underline",
}));

export const AddFiles = styled.div<{ hidden: boolean; isButton: boolean }>(props => ({
    display: props.hidden ? "none" : "block",
    marginTop: props.isButton ? 0 : `${theme(props).size(2)}`,
}));
